import { guideCards } from '@/mocks/movies';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-8">
        <SectionHeading
          eyebrow="选片指南"
          title="把「看什么」这件事变得简单"
          subtitle="四个实用思路，帮你在几分钟内从茫茫片单里挑出今晚最合适的那一部。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {guideCards.map((card) => (
            <article
              key={card.title}
              className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors duration-300 hover:border-accent-300"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className={`${card.icon} text-xl`} aria-hidden="true" />
              </span>
              <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{card.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{card.desc}</p>
              <ul className="mt-1 flex flex-col gap-2 border-t border-background-200 pt-3">
                {card.tips.map((tip) => (
                  <li key={tip} className="flex items-start gap-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                    <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-primary-500" aria-hidden="true" />
                    <span>{tip}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}